export default __webpack_public_path__ + "static/media/placeholder.59043ca2.svg";